import React, { Component } from 'react'
import { Button, Flex } from 'hljd'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import QRCode from 'qrcode.react'
import style from '../style.module.less'
import { TITLE, DESC, STATUS } from '../constant'
import SelectModal from './SelectModal'

@inject('globalMainStore')
@observer
export default class extends Component {
  submitClick = property_id => {
    this.props.store.setPropertyId(property_id)
    this.props.store.showModal()
  }
  alterClick = property_id => {
    this.props.store.setPropertyId(property_id)
    this.props.store.getSelectedMaterial()
    this.props.store.showModal()
  }
  render() {
    const { closeDialog, yearReviewStatus } = this.props.store
    const { property_id, city_code } = toJS(
      this.props.globalMainStore.merchantInfo
    )
    // eslint-disable-next-line
    const votePage = `https:${__HUNLIJI_DOMAIN__}/p/frontend/wap/activities/20201215-annual-merchant/?cid=${city_code}&property=${property_id}#/vote`
    // eslint-disable-next-line
    const announcePage = `https:${__HUNLIJI_DOMAIN__}/p/frontend/wap/activities/20201215-annual-merchant/?cid=${city_code}&property=${property_id}#/`
    return (
      <>
        {yearReviewStatus == 4 || yearReviewStatus == 5 ? (
          <div className={style.yearMerchant_submit_stage}>
            <div className={style.angle} />
            {yearReviewStatus == 5 && (
              <div className={style.close} onClick={closeDialog}>
                <img src="https://qnm.hunliji.com/Fra4HbuNUhitExikl3puQz3l-6Q9" />
              </div>
            )}
            <Flex vc hc d="v">
              <h3>{TITLE[yearReviewStatus]}</h3>
              <div style={{ margin: '20px 0 16px', position: 'relative' }}>
                <img
                  src="https://qnm.hunliji.com/FspH3S7OugIo3xkjdg2_S6LAWnEX"
                  className={style.annual_prize}
                />
                {yearReviewStatus == 4 ? (
                  <span className={style.desc1}>{DESC[yearReviewStatus]}</span>
                ) : (
                  <span className={style.desc1} style={{ color: '#999' }}>
                    {DESC[yearReviewStatus]}
                  </span>
                )}
              </div>
              {yearReviewStatus == 4 ? (
                <Button
                  type="primary"
                  onClick={() => this.submitClick(property_id)}
                >
                  立即提交
                </Button>
              ) : (
                <Button
                  type="primary"
                  onClick={() => this.alterClick(property_id)}
                >
                  我要修改
                </Button>
              )}
            </Flex>
          </div>
        ) : (
          <div className={style.yearMerchant_vote_statge}>
            <div className={style.angle} />
            <div className={style.close} onClick={closeDialog}>
              <img src="https://qnm.hunliji.com/Fra4HbuNUhitExikl3puQz3l-6Q9" />
            </div>
            <Flex vc hc d="v">
              <h3>{TITLE[yearReviewStatus]}</h3>
              <div
                style={{
                  border: '1px solid #FD9037',
                  borderRadius: 2,
                  padding: 4,
                  margin: '16px 0 10px',
                  position: 'relative'
                }}
              >
                {/* <img
                  src="https://qnm.hunliji.com/FspH3S7OugIo3xkjdg2_S6LAWnEX"
                  className={style.annual_prize}
                /> */}
                <span className={style.status}>{STATUS[yearReviewStatus]}</span>
              </div>
              {yearReviewStatus == 3 ? (
                <QRCode value={announcePage} size={160} />
              ) : (
                <QRCode value={votePage} size={160} />
              )}
              <span
                className={style.desc}
                style={{ marginBottom: 0, marginTop: 10 }}
              >
                {DESC[yearReviewStatus]}
              </span>
            </Flex>
          </div>
        )}
        <SelectModal store={this.props.store} />
      </>
    )
  }
}
